import styled from 'styled-components';
import { device } from '../../../utils/responsive_utilities';

export const StyledAnimation = styled.div`
  width: 75rem;
  height: 45rem;
  margin: 0 auto;
  position: relative;

  @media ${device.TabletLandscape}{
    top: 11rem;
    margin: unset;
    left: 50%;
    transform: translate(-50%, -30%) scale(1.2);
  }
  @media ${device.Tablet}{
    margin: unset;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -30%) scale(1.3);
  }
  @media ${device.PhoneTabletLandscape} {
    width: 45.6rem;
    height: 20rem;
    left: 50%;
    top: 30%;
    margin: unset;
    transform: translate(-50%, -30%) scale(1.2);
  }
  @media ${device.Phone} {
    width: 34.2rem;
    height: 23.2rem;
    margin: unset;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -30%) scale(1.3);
  }
`;

export const OpaqueCta = styled.button`
  border: 0;
  padding: 5.5rem;
  outline: none;
  background-color: transparent;
  position: absolute;
  z-index: 1;
  left: ${props=>props.left ? props.left : 0}%;
  top: ${props=>props.top ? props.top : 0}%;
  cursor: pointer;
  @media ${device.PhoneTabletLandscape} {
    padding: 2.8rem;
  }
  @media ${device.Phone} {
    padding: 2.4rem;
  }
`;